"use client";

import Script from "next/script";
import Z1_CAPTURE_SCRIPT from "lib/sessionai/z1-capture.inline";

/**
 * App Router parity for the Pages Router injection in `pages/_document.tsx`.
 * Shares the same IIFE source so both routers push the identical
 * `z1_analytic_capture` payload. The IIFE's `window.__z1CaptureInstalled`
 * guard makes it idempotent if both ever execute for the same window.
 */
export function Z1CaptureScript() {
  return (
    <Script
      dangerouslySetInnerHTML={{ __html: Z1_CAPTURE_SCRIPT }}
      id="z1-capture"
    />
  );
}
